import { jsx as _jsx } from "react/jsx-runtime";
import { Tablet } from '@hellodarwin/core/lib/components/common/Media';
import { Suspense } from 'react';
import { ContainerIcons } from './icon-entities';
import { IconStyled } from './styles';
const BackgroundIcon = ({ iconParams }) => {
    const Icon = ContainerIcons[iconParams.icon];
    return (_jsx(Tablet, { direction: "up", inactive: !(iconParams === null || iconParams === void 0 ? void 0 : iconParams.desktopOnly), children: _jsx(IconStyled, { "$params": iconParams, children: _jsx(Suspense, { fallback: "", children: _jsx(Icon, { width: iconParams.width, height: iconParams.height, color: iconParams.color }) }) }) }));
};
export default BackgroundIcon;
